import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import { LookupMesaExamen } from '../MesaExamen/LookupMesaExamen';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
  classifyInscripcionesError,
  toInscripcionExamenMultiplePayload,
  validateInscripcionExamenMultipleForm,
} from '../../services/inscripciones/inscripcionesDto';
import {
  formatMesaExamenInscripcionCardDisplay,
  parseLookupMesaExamenValue,
} from '../../services/mesas/mesasDto';
import Select from '../common/AppSelect';
import { MdPageErrorMessage } from '../common/mdPageErrorMessage';
import { getSelectOptionValue } from '../../services/selectOptions';

const optionsCuatrimestre = [
  { value: 'Regular', label: 'Regular' },
  { value: 'Libre', label: 'Libre' },
  { value: 'Equivalencia', label: 'Equivalencia' },
  { value: 'Promocion', label: 'Promoción' },
];

const emptyCondicionOption = { value: '', label: '' };

function countMesasWithCondicion(mesas) {
  return mesas.filter((mesa) => getSelectOptionValue(mesa.condicion, '').trim().length > 0).length;
}

function hasDuplicateInscripcion(mesas, materiaCarreraCod, condicion, excludeId) {
  const condicionValue = getSelectOptionValue(condicion, '').trim();
  if (!condicionValue) {
    return false;
  }
  return mesas.some((mesa) => (
    mesa.id !== excludeId
    && mesa.materiaCarreraCod === materiaCarreraCod
    && getSelectOptionValue(mesa.condicion, '').trim() === condicionValue
  ));
}

export class AddInscripcionExamen extends Component {
  static displayName = AddInscripcionExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      showCursada: false,
      alumno: { codigo: '', descripcion: '' },
      mesas: [],
      carreraCursada: -1,
      ignorarCorrelatividad: false,
      ignorarRegularidad: false,
    };
  }

  handleConfirmButton = () => {
    if (!validateInscripcionExamenMultipleForm({
      alumnoPresent: this.state.alumno.descripcion.trim().length > 0,
      mesaCount: this.state.mesas.length,
      mesasWithCondicionCount: countMesasWithCondicion(this.state.mesas),
    })) {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
      return;
    }
    this.saveStudent();
  };

  async componentDidMount() {
    await constantClass.canAccess('WWInscripcionExamen');
  }

  handleRemoveMesa = (id) => {
    this.setState({
      mesas: this.state.mesas.filter((mesa) => mesa.id !== id),
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleMesaCondicionChange = (id, condicion) => {
    const mesa = this.state.mesas.find((item) => item.id === id);
    if (!mesa) {
      return;
    }
    if (hasDuplicateInscripcion(this.state.mesas, mesa.materiaCarreraCod, condicion, id)) {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Ya existe una inscripción con la misma materia y condición.',
      });
      return;
    }
    this.setState({
      mesas: this.state.mesas.map((item) => (
        item.id === id ? { ...item, condicion } : item
      )),
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleShowCursadaLookup = () => {
    this.setState({ showCursada: true });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleHideLookup1 = () => {
    this.setState({ showCursada: false });
  };

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
      carreraCursada: Number(carreraProperties[3]),
      mesas: [],
      alumno: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1] + ' - ' + carreraProperties[2],
      },
    });
  };

  handleSelectCursadaItem = (e) => {
    const mesa = parseLookupMesaExamenValue(e);
    if (this.state.mesas.some((item) => item.id === mesa.mesaExamenCod)) {
      this.setState({ showCursada: false });
      return;
    }
    this.setState({
      showCursada: false,
      showErrorMessage: false,
      errorMessage: '',
      mesas: this.state.mesas.concat({
        id: mesa.mesaExamenCod,
        text: formatMesaExamenInscripcionCardDisplay(mesa),
        materiaCarreraCod: mesa.materiaCarreraCod,
        condicion: emptyCondicionOption,
      }),
    });
  };

  handleCheckBoxCorrelatividad = (e) => {
    this.setState({ ignorarCorrelatividad: e.target.checked });
  };

  handleCheckBoxRegularidad = (e) => {
    this.setState({ ignorarRegularidad: e.target.checked });
  };

  renderMesaList() {
    if (!this.state.mesas.length) {
      return null;
    }
    return (
      <ul className="md-add-inscripcion-examen__mesa-list">
        {this.state.mesas.map((mesa) => (
          <li key={mesa.id} className="md-add-inscripcion-examen__mesa-card">
            <div className="md-add-inscripcion-examen__mesa-card-header">
              <span className="md-add-inscripcion-examen__mesa-card-label">{mesa.text}</span>
              {!this.state.loading ? (
                <button
                  type="button"
                  className="md-add-inscripcion-examen__mesa-card-remove"
                  aria-label={'Quitar mesa ' + mesa.text}
                  onClick={() => this.handleRemoveMesa(mesa.id)}
                >
                  ×
                </button>
              ) : null}
            </div>
            <Select
              inputId={'mesa-condicion-' + mesa.id}
              className="md-add-inscripcion-examen__mesa-card-select md-page__field-select"
              value={mesa.condicion}
              options={optionsCuatrimestre}
              onChange={(option) => this.handleMesaCondicionChange(mesa.id, option)}
              isDisabled={this.state.loading}
              placeholder="Seleccione condición"
            />
          </li>
        ))}
      </ul>
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-ie" />;
    }

    const { loading } = this.state;
    const alumnoDisplay = this.state.alumno.descripcion.trim();
    const canSelectMesa = !loading && this.state.carreraCursada !== -1;

    return (
      <div className="md-page md-add-inscripcion-examen">
        <Link className="md-page__back-link" to="/md-ie">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Inscripción a Examen</h1>
          <p className="md-page__subtitle">
            Seleccione el alumno, una o más mesas de examen y la condición de cada inscripción.
          </p>
        </div>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <MdPageErrorMessage message={this.state.errorMessage} />
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccione el Alumno
                </button>
              ) : null}
              <div className="md-page__field-readonly">{alumnoDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Mesas de Examen</span>
            <div className="md-page__picker-block">
              {canSelectMesa ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                  Seleccione la Mesa de Examen
                </button>
              ) : (
                <p className="md-page__file-hint">Seleccione un alumno antes de elegir las mesas de examen.</p>
              )}
              {this.renderMesaList()}
            </div>
          </div>

          <div className="md-add-inscripcion-examen__options">
            <label className="md-add-inscripcion-examen__option">
              <input
                type="checkbox"
                checked={this.state.ignorarCorrelatividad}
                onChange={this.handleCheckBoxCorrelatividad}
                disabled={loading}
              />
              {' '}Ignorar verificación de correlatividad
            </label>

            <label className="md-add-inscripcion-examen__option">
              <input
                type="checkbox"
                checked={this.state.ignorarRegularidad}
                onChange={this.handleCheckBoxRegularidad}
                disabled={loading}
              />
              {' '}Ignorar verificación de regularidad
            </label>
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showLookupAnios ? (
          <LookupAlumnoCarrera selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showCursada ? (
          <LookupMesaExamen
            carreraCod={this.state.carreraCursada}
            selectItem={this.handleSelectCursadaItem}
            hideLookup={this.handleHideLookup1}
          />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    const mesas = this.state.mesas.map((mesa) => ({
      mesa: parseInt(mesa.id, 10),
      materiaCarreraCod: mesa.materiaCarreraCod,
      condicion: getSelectOptionValue(mesa.condicion, ''),
    }));
    try {
      await inscripcionesService.saveInscripcionesExamenMultiple(toInscripcionExamenMultiplePayload({
        alumnoxCarreraCod: this.state.alumno.codigo,
        mesas,
        ignorarCorrelatividad: this.state.ignorarCorrelatividad,
        ignorarRegularidad: this.state.ignorarRegularidad,
      }));
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
